import { SeenState } from "../models/SeenState";
import api from "./api"; // custom axios instance

export const SeenStateService = {
  async getSeenState(seenStateId: string): Promise<SeenState> {
    const res = await api.post(`/api/v1/seen-states/${seenStateId}`);
    return res.data?.data?._id;
  },

  async createSeenState(seenState: Partial<SeenState>): Promise<string> {
    const res = await api.post("/api/v1/seen-states", seenState);
    return res.data?.data?._id;
  },

  async updateSeenState(
    seenStateId: string,
    seenStateData: Partial<Omit<SeenState, "_id">>,
  ): Promise<void> {
    await api.put(`/api/v1/seen-states/${seenStateId}`, seenStateData);
  },

  async deleteSeenState(seenStateId: string): Promise<void> {
    await api.delete(`/api/v1/seen-states/${seenStateId}`);
  },
};
